import { Paper } from "@material-ui/core";

const PaperAutocomplete = (props) => {
    return <Paper style={{ width: "fit-content" }}>{props.children}</Paper>
};

export default PaperAutocomplete;
